import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Dialog.scss';

var DialogBody = /*#__PURE__*/function (_Component) {
  _inherits(DialogBody, _Component);

  var _super = _createSuper(DialogBody);

  function DialogBody() {
    _classCallCheck(this, DialogBody);

    return _super.apply(this, arguments);
  }

  _createClass(DialogBody, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.dialog
      }, /*#__PURE__*/React.createElement("h1", null, this.props.title), /*#__PURE__*/React.createElement("div", {
        className: styles.body
      }, this.props.body), /*#__PURE__*/React.createElement("div", {
        className: styles.buttonRow,
        style: this.props.buttonDirection ? {
          flexDirection: this.props.buttonDirection
        } : {}
      }, this.props.buttons));
    }
  }]);

  return DialogBody;
}(Component);

_defineProperty(DialogBody, "propTypes", {
  title: PropTypes.string,
  body: PropTypes.node,
  buttons: PropTypes.arrayOf(PropTypes.node).isRequired,
  buttonDirection: PropTypes.oneOf(['row', 'column'])
});

export { DialogBody as default };